<template>
  <div class="content">
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
        <p>Loading...</p>
      </div>
    </div>
    <div>
      <div class="md-layout-item md-size-100 text-right">
        <span v-if="successMsg" class="success_msg">{{successMsg}}</span>
        <md-button 
            class="md-raised md-primary mx-3" 
            @click="updateData(1)"
            :disabled="isLoading"
        >
          Update
        </md-button>
        <md-button 
            class="md-raised md-primary" 
            @click="updateData(0)"
            :disabled="isLoading"
        >
          Publish
        </md-button>
      </div>
    </div>
    <div>
      <nav-tabs-card>
        <template slot="content">
          <md-tabs class="md-primary" md-alignment="left" ref="tabs">
            <md-tab
                id="tab-home"
                md-icon="contacts"
                md-label="Basic Info"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Basic info</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>External Listing Name</label>
                              <md-input v-model="basic_info.external_listing_name" placeholder="Name"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Person capacity</label>
                              <md-select v-model="basic_info.person_capacity" name="person_capacity" id="person_capacity">
                                <md-option :value="null" disabled selected>Select capacity</md-option>
                                <md-option
                                    v-for="item in personCapacities"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Tags</label>
                              <md-select
                                  v-if="Array.isArray(basic_info.tags_ids)"
                                  md-multiple
                                  name="tags"
                                  id="tags"
                                  @md-selected="onTagSelected"
                              >
                                <md-option
                                    v-for="tag in tagOptions"
                                    :key="tag.id"
                                    :value="tag.id"
                                    :disabled="basic_info.tags_ids.includes(tag.id)"
                                >
                                  {{ tag.name }}
                                </md-option>
                                <md-option v-if="tagOptions.length === 0" disabled>
                                  No tags found
                                </md-option>
                              </md-select>
                            </md-field>

                            <div v-if="hasSelectedTags" class="selected-tags mt-2">
                              <md-chip
                                  v-for="tagId in basic_info.tags_ids"
                                  :key="tagId"
                                  md-deletable
                                  @md-delete="removeTag(tagId)"
                                  class="mr-1 mb-1"
                              >
                                {{ getTagName(tagId) }}
                              </md-chip>
                            </div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Property type</label>
                              <md-select v-model="basic_info.property_type_id" name="property_type" id="property_type">
                                <md-option :value="null" disabled>Select type</md-option>
                                <md-option
                                    v-for="item in propertyTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field maxlength="6">
                              <label>Description</label>
                              <md-textarea v-model="basic_info.description" placeholder="Description"></md-textarea>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Room type</label>
                              <md-select v-model="basic_info.room_type_id" name="room_type" id="room_type">
                                <md-option
                                    v-for="item in roomTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            
                            </md-field>
                            <md-field>
                              <label>Number of bedrooms</label>
                              <md-select v-model="basic_info.number_of_bedrooms" name="number_of_bedrooms" id="number_of_bedrooms">
                                <md-option
                                    v-for="item in numberOfBedrooms"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Number of beds</label>
                              <md-select v-model="basic_info.number_of_beds" name="number_of_beds" id="number_of_beds">
                                <md-option
                                    v-for="item in numberOfBeds"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                            <md-field>
                              <label>Number of bathrooms</label>
                              <md-select v-model="basic_info.number_of_bathrooms" name="number_of_bathrooms" id="number_of_bathrooms">
                                <md-option
                                    v-for="item in numberOfBathrooms"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                            <md-field>
                              <label>Bathroom type</label>
                              <md-select v-model="basic_info.bathroom_type_id" name="bathroom_type" id="bathroom_type">
                                <md-option
                                    v-for="item in bathroomTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            
                            </md-field>
                            <md-field>
                              <label>Number of guest bathrooms</label>
                              <md-select v-model="basic_info.number_of_guest_bathrooms" name="number_of_guest_bathrooms" id="number_of_guest_bathrooms">
                                <md-option
                                    v-for="item in numberOfGuestBathrooms"
                                    :key="item.id"
                                    :value="item.number">
                                  {{ item.number }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <!--                <div class="md-layout-item md-size-100 text-right">-->
                          <!--                  <md-button class="md-raised md-success">Update Profile</md-button>-->
                          <!--                </div>-->
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="address"
                md-label="Address"
                md-icon="place"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Address</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <div>
                              <l-map
                                  v-if="lat && lng"
                                  :zoom="16"
                                  :center="[lat, lng]"
                                  style="height: 500px; width: 100%"
                                  :options="{ attributionControl: false }"
                              >
                                <l-tile-layer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                ></l-tile-layer>

                                <l-marker :lat-lng="[lat, lng]">
                                  <l-popup>{{ setAddress }}</l-popup>
                                </l-marker>
                              </l-map>
                              <div v-else style="height: 500px; width: 100%; display: flex; align-items: center; justify-content: center; background: #f0f0f0;">
                                <p>Loading map or no coordinates available...</p>
                              </div>
                            </div>
<!--                            <Maps/>-->
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field >
                              <label>Address</label>
                              <md-input v-model="address.address" md-placeholder="Address" @input="checkMap"></md-input>
                              <!-- <span class="md-error" v-if="showErrors && !address.address">
                                Address is required
                              </span> -->
                            </md-field>
                            <md-field md-dense>
                              <label>Public address</label>
                              <md-input v-model="address.public_address" md-placeholder="Public Address"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Country</label>
                              <md-input v-model="address.country" md-placeholder="Country" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>State</label>
                              <md-input v-model="address.state" md-placeholder="State" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>City</label>
                              <md-input v-model="address.city" md-placeholder="City" @input="checkMap"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Street</label>
                              <md-input v-model="address.street" md-placeholder="Street"></md-input>
                            </md-field>
                            <md-field md-dense>
                              <label>Zip code / Postcode</label>
                              <md-input v-model="address.zip_code" md-placeholder="Zip code"></md-input>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="media"
                md-label="Media"
                md-icon="camera"
                class="h-auto"
            >
              <div class="media_tab">
                <div class="title">
                  <h4>Media</h4>
                  <div
                      class="dropzone_container"
                      @dragover="dragover"
                      @dragleave="dragleave"
                      @drop="drop"
                      :style="isDragging && 'border-color: green;'"
                  >
                    <input
                        type="file"
                        multiple
                        name="file"
                        id="fileInput"
                        class="dropzone_input"
                        @change="onChange"
                        ref="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                    />
                    <label for="fileInput" class="dropzone_label">
                      <div v-if="isDragging">Release to drop files here.</div>
                      <div v-else>Drop files here or <u>click here</u> to upload.</div>
                      <p>Minimum size requirement for photos: 1024 x 683 pixels</p>
                    </label>
                  </div>
                </div>
                <div class="media_main">
                  <div class="preview_container mr-1" v-if="files.length">
                    <div v-for="file in files" :key="file.name" class="preview_card">
                      <div class="preview_card-item">
                        <img class="preview_img" :alt="file.name"  :src="generateURL(file)"  />
                        <p>
                          <!--                          {{ file.name }} - {{ Math.round(file.size / 1000) + "kb" }}-->
                        </p>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <md-field md-dense>
                            <label>Airbnb caption</label>
                            <md-input v-model="file.image_sequences" md-placeholder="Airbnb caption"></md-input>
                          </md-field>
                        </div>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <md-field md-dense>
                            <label>Vrbo caption</label>
                            <md-input v-model="file.vrbo_caption" md-placeholder="Vrbo caption"></md-input>
                          </md-field>
                        </div>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <md-field md-dense>
                            <label>Booking Engine caption</label>
                            <md-input v-model="file.engine_caption" md-placeholder="Booking Engine caption"></md-input>
                          </md-field>
                        </div>
                      </div>
                      <button
                          class="preview_card-close ml-2"
                          type="button"
                          @click="remove(files.indexOf(file))"
                          title="Remove file"
                      >
                        ×
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </md-tab>
            <md-tab id="home" md-label="Amenities" md-icon="home">
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100 px-0">
                  <div class="title">
                    <h4>
                      Amenities
                      <md-chip
                          v-if="selectedAmenityCount > 0"
                          class="md-primary ml-2"
                          md-dense
                      >
                        {{ selectedAmenityCount }} selected
                      </md-chip>
                    </h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <!-- Action Buttons -->

                        <div class="md-layout md-gutter flex-column">
                          <div
                              class="md-layout-item md-small-size-100 md-size-50"
                              v-for="(amenity, index) in amenities"
                              :key="index"
                          >
                            <md-checkbox
                                v-model="amenity.checked"
                                class="md-primary m-1"
                            >
                              {{ amenity.name }}
                            </md-checkbox>
                          </div>
                        </div>
<!--                        <div>-->
<!--                          <md-table-->
<!--                              v-model="amenities"-->
<!--                              v-model:md-selected="selectedAmenities"-->
<!--                              md-selectable="multiple"-->
<!--                              md-auto-select-->
<!--                          >-->
<!--                            <md-table-row-->
<!--                                slot="md-table-row"-->
<!--                                slot-scope="{ item }"-->
<!--                            >-->
<!--                              <md-table-cell>{{ item.name }}</md-table-cell>-->
<!--                            </md-table-row>-->
<!--                          </md-table>-->
<!--                        </div>-->



<!--                        <div class="amenities-actions mb-3">-->
<!--                          <md-button-->
<!--                              class="md-dense md-primary"-->
<!--                              @click="selectAllAmenities"-->
<!--                              :disabled="selectedAmenityCount === amenities.length"-->
<!--                          >-->
<!--                            Select All-->
<!--                          </md-button>-->
<!--                          <md-button-->
<!--                              class="md-dense md-accent ml-2"-->
<!--                              @click="clearAllAmenities"-->
<!--                              :disabled="selectedAmenityCount === 0"-->
<!--                          >-->
<!--                            Clear All-->
<!--                          </md-button>-->
<!--                        </div>-->

<!--                        <div class="amenities-grid">-->
<!--                          <md-card-->
<!--                              v-for="amenity in amenities"-->
<!--                              :key="amenity.id"-->
<!--                              class="amenity-card"-->
<!--                              :class="{ 'selected': isAmenitySelected(amenity) }"-->
<!--                              @click="toggleAmenity(amenity)"-->
<!--                              md-with-hover-->
<!--                          >-->
<!--                            <md-card-content>-->
<!--                              <div class="amenity-content">-->
<!--                                <md-checkbox-->
<!--                                    :value="isAmenitySelected(amenity)"-->
<!--                                    @change="toggleAmenity(amenity)"-->
<!--                                    class="amenity-checkbox"-->
<!--                                />-->
<!--                                <md-icon class="amenity-icon">{{ getAmenityIcon(amenity.name) }}</md-icon>-->
<!--                                <span class="amenity-name">{{ amenity.name }}</span>-->
<!--                              </div>-->
<!--                            </md-card-content>-->
<!--                          </md-card>-->
<!--                        </div>-->


<!--                        <div class="amenities-table-container">-->
<!--                          <md-table-->
<!--                              v-model="selected_amenities"-->
<!--                              :md-data="amenities"-->
<!--                              md-selectable="multiple"-->
<!--                              md-auto-select-->
<!--                              @md-selected="onSelect"-->
<!--                              table-header-color="green"-->
<!--                          >-->
<!--                            <md-table-row-->
<!--                                slot="md-table-row"-->
<!--                                slot-scope="{ item }"-->
<!--                                :class="{ 'selected-amenity-row': isAmenitySelected(item) }"-->
<!--                            >-->
<!--                              <md-table-cell>-->
<!--                                <div class="amenity-item">-->
<!--                                  <md-icon-->
<!--                                      :class="isAmenitySelected(item) ? 'md-primary' : 'md-disabled'"-->
<!--                                      class="amenity-icon"-->
<!--                                  >-->
<!--                                    {{ getAmenityIcon(item.name) }}-->
<!--                                  </md-icon>-->
<!--                                  <span class="amenity-name">{{ item.name }}</span>-->
<!--                                </div>-->
<!--                              </md-table-cell>-->
<!--                            </md-table-row>-->
<!--                          </md-table>-->
<!--                        </div>-->



                        <!-- Selected Amenities Summary -->
<!--                        <div v-if="selectedAmenityCount > 0" class="selected-amenities-summary mt-4">-->
<!--                          <h5>Selected Amenities ({{ selectedAmenityCount }}):</h5>-->
<!--                          <div class="selected-amenities-chips">-->
<!--                            <md-chip-->
<!--                                v-for="amenity in selected_amenities"-->
<!--                                :key="amenity.id"-->
<!--                                md-deletable-->
<!--                                @md-delete="toggleAmenity(amenity)"-->
<!--                                class="mr-1 mb-1"-->
<!--                            >-->
<!--                              <md-icon class="mr-1">{{ getAmenityIcon(amenity.name) }}</md-icon>-->
<!--                              {{ amenity.name }}-->
<!--                            </md-chip>-->
<!--                          </div>-->
<!--                        </div>-->

                        <!-- No Selection Message -->
<!--                        <div v-else class="no-amenities-selected mt-4">-->
<!--                          <p class="text-muted">No amenities selected. Choose from the list above.</p>-->
<!--                        </div>-->



                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="price"
                md-label="Price & fees"
                md-icon="money"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Price & fees</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <v-select
                                  v-model="price_and_fees.currency_code"
                                  :options="currencyOptions"
                                  label="code"
                                  :reduce="currency => currency.code"
                                  placeholder="Type or select currency"
                                  class="currency_code"

                              />
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Price</label>
                              <md-input v-model="price_and_fees.price" type="number" placeholder="Price"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Price for extra person</label>
                              <md-input v-model="price_and_fees.price_fo_extra_person" type="number" placeholder="Price for extra person"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Guests included</label>
                              <md-input v-model="price_and_fees.guests_included" type="number" placeholder="Guests included"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Refundable damage deposit fee</label>
                              <md-input v-model="price_and_fees.refundable_damage_deposit" type="number" placeholder="Refundable damage deposit fee"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Cleaning fee</label>
                              <md-input v-model="price_and_fees.cleaning_fee" type="number" placeholder="Cleaning fee"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Weekly discount</label>
                              <md-input v-model="price_and_fees.weekly_discount" type="number" placeholder="Weekly discount"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Monthly discount</label>
                              <md-input v-model="price_and_fees.monthly_discount" type="number" placeholder="Monthly discount"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-100">
                            <md-table v-model="exclude_from_reservation" @md-selected="onSelectReservation">
                              <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                  md-selectable="multiple"
                                  md-auto-select
                              >
                                <md-table-cell>{{ item.name }}</md-table-cell>
                              </md-table-row>
                            </md-table>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="additional_info"
                md-label="Additional info"
                md-icon="info"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Additional Info</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>House rules</label>
                              <md-input v-model="additional_info.house_rules" md-placeholder="House rules"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>House manual</label>
                              <md-input v-model="additional_info.house_manual" md-placeholder="House manual"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Key pickup</label>
                              <md-input v-model="additional_info.key_pickup" md-placeholder="Key pickup"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Special instruction</label>
                              <md-input v-model="additional_info.special_instruction" md-placeholder="Special instruction"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Door code <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="right" title="Door code"></i></label>
                              <md-input v-model="additional_info.door_code" md-placeholder="Door code"></md-input>
                            </md-field>

                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Bed type</label>
                              <md-input v-model="additional_info.bed_type" md-placeholder="Bed type"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">

                            <md-table v-model="additional_info_checkbox" @md-selected="onSelectAdditional">
                              <md-table-row
                                  slot="md-table-row"
                                  slot-scope="{ item }"
                                  md-selectable="multiple"
                                  md-auto-select
                              >
                                <md-table-cell>{{ item.name }}</md-table-cell>
                              </md-table-row>
                            </md-table>

                            <!--                            -->
                            <!--                            <md-field>-->
                            <!--                              <label>Automatically generate a door code</label>-->
                            <!--                              <md-input v-model="additional_info.automatically_generate_a_door_cod" md-placeholder="Automatically generate a door code"></md-input>-->
                            <!--                            </md-field>-->
                            <!--                            <md-field>-->
                            <!--                              <label>Phone number-based code</label>-->
                            <!--                              <md-input v-model="additional_info.phone_number_based_code" md-placeholder="Phone number-based code"></md-input>-->
                            <!--                            </md-field>-->



                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Listing's cleanliness status</label>
                              <md-select v-model="additional_info.listings_cleanliness_status">
                                <md-option value="Not Set">Not Set</md-option>
                                <md-option value="Clean">Clean</md-option>
                                <md-option value="Not Clean">Not Clean</md-option>
                              </md-select>
                            </md-field>
                            <!--                            <md-field>-->
                            <!--                              <label>Listing's cleanliness status</label>-->
                            <!--                              <md-input v-model="additional_info.listings_cleanliness_status" md-placeholder="Listing's cleanliness status"></md-input>-->
                            <!--                            </md-field>-->
                            <md-field>
                              <label>Cleaning instruction</label>
                              <md-input v-model="additional_info.cleaning_instruction" md-placeholder="Cleaning instruction"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Wi-fi username</label>
                              <md-input v-model="additional_info.wi_fi_username" md-placeholder="Wi-fi username"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Wi-fi password</label>
                              <md-input v-model="additional_info.wi_fi_password" md-placeholder="Wi-fi password"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Check in Time Start</label>
                              <md-select v-model="additional_info.check_in_time_start" name="check_in_time_start" id="check_in_time_start">
                                <md-option
                                    v-for="item in times"
                                    :key="item.id"
                                    :value="item.time">
                                  {{ item.time }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Check in Time End</label>
                              <md-select v-model="additional_info.check_in_time_end" name="check_in_time_end" id="check_in_time_end">
                                <md-option
                                    v-for="item in times"
                                    :key="item.id"
                                    :value="item.time">
                                  {{ item.time }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Check out Time</label>
                              <md-select v-model="additional_info.check_out_time" name="check_out_time" id="check_out_time">
                                <md-option
                                    v-for="item in times"
                                    :key="item.id"
                                    :value="item.time">
                                  {{ item.time }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="contact_invoicing"
                md-label="Contact And Invoicing"
                md-icon="person"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Contact and Invoicing</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Contact person's name</label>
                              <md-input v-model="contact_invoicing.contact_name" md-placeholder="Contact person's name"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Contact person's last name</label>
                              <md-input v-model="contact_invoicing.contact_surname" md-placeholder="Contact person's last name"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Phone number</label>
                              <md-input v-model="contact_invoicing.phone_number" type="number" md-placeholder="Phone number"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Second phone number</label>
                              <md-input v-model="contact_invoicing.second_phone_number" type="number" md-placeholder="Second phone number"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Contact person's spoken language</label>
                              <md-input v-model="contact_invoicing.contact_language" md-placeholder="Contact person's spoken language"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Contact person's email</label>
                              <md-input v-model="contact_invoicing.contact_email" type="email" md-placeholder="Contact person's email"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Contact person's address</label>
                              <md-input v-model="contact_invoicing.contact_address" md-placeholder="Contact person's address"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Tax ID</label>
                              <md-input v-model="contact_invoicing.tax_id" md-placeholder="Tax ID"></md-input>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab id="attachment" md-label="Attachment" md-icon="upload">
              <div class="attachment_tab">
                <div class="title">
                  <h4>Attachments</h4>
                  <div
                      class="dropzone_container"
                      @dragover="dragoverAttach"
                      @dragleave="dragleaveAttach"
                      @drop="dropAttach"
                      :style="isDraggingAttach && 'border-color: green;'"
                  >
                    <input
                        type="file"
                        multiple
                        name="attachments"
                        id="attachmentsInput"
                        class="dropzone_input"
                        @change="onChangeAttach"
                        ref="fileAttach"
                        accept=".pdf"
                    />
                    <label for="attachmentsInput" class="dropzone_label">
                      <div v-if="isDraggingAttach">Release to drop files here.</div>
                      <div v-else>Drop files here or <u>click here</u> to upload.</div>
                    </label>
                  </div>
                </div>
                <div class="media_main">
                  <div class="preview_container mr-1" v-if="attachments.length">
                    <div v-for="(file, index) in attachments" :key="file.id || file.name + file.size" class="preview_card">
                      <div class="preview_card-item">
                        <embed :src="generateURL(file)" type="application/pdf" width="100%" />
                        <p class="py-2">{{ file.name }} - {{ file.size ? Math.round(file.size / 1000) + ' KB' : '' }}</p>
                        <div class="preview_card_input-item md-layout-item md-small-size-100 md-size-100">
                          <input
                              v-model="file.attachments_is_public"
                              :true-value="1"
                              :false-value="0"
                              type="checkbox"
                          />
                          <label class="p-2">Attachments is public</label>
                        </div>
                      </div>
                      <button
                          class="preview_card-close ml-2"
                          type="button"
                          @click="removeAttach(index)"
                          title="Remove file"
                      >
                        ×
                      </button>
                    </div>
                  </div>

                  
                </div>
              </div>
            </md-tab>
            <md-tab
                id="booking"
                md-label="Booking settings"
                md-icon="event"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Booking settings</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Minimum nights</label>
                              <md-input v-model="booking_settings.minimum_nights" type="number" md-placeholder="Minimum nights"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Maximum nights</label>
                              <md-input v-model="booking_settings.maximum_nights" type="number" md-placeholder="Maximum nights"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <div class="pt-3">
                              <input
                                  v-model="booking_settings.enable_reservations_for_gap_nights"
                                  :true-value="1"
                                  :false-value="0"
                                  type="checkbox" />
                              <label class="mx-2">Gap nights</label>
                            </div>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Smallest allowed gap</label>
                              <md-input v-model="booking_settings.smallest_allowed_gap" type="number" md-placeholder="Smallest allowed gap"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Allow gaps between start</label>
                              <md-input v-model="booking_settings.allow_gaps_between_start" type="number" md-placeholder="Allow gaps between start"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Allow gaps between end</label>
                              <md-input v-model="booking_settings.allow_gaps_between_end" type="number" md-placeholder="Allow gaps between end"></md-input>
                            </md-field>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                </div>
              </div>
            </md-tab>
            <md-tab
                id="bad_types"
                md-label="Bed types"
                md-icon="bed"
            >
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-100 md-size-100">
                  <div class="title">
                    <h4>Bed Types</h4>
                  </div>
                  <form>
                    <md-card>
                      <md-card-content>
                        <div class="md-layout">
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Bed Type*</label>
                              <md-select v-model="newRoom.bed_type_id" name="bed_type" id="bed_type">
                                <md-option
                                    v-for="item in allBedTypes"
                                    :key="item.id"
                                    :value="item.id">
                                  {{ item.name }}
                                </md-option>
                              </md-select>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Room Number*</label>
                              <md-input v-model="newRoom.room_number" md-placeholder="Room Number"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field>
                              <label>Quantity*</label>
                              <md-input v-model="newRoom.quantity" md-placeholder="Quantity"></md-input>
                            </md-field>
                          </div>
                          <div class="md-layout-item md-small-size-100 md-size-50 text-right">
                            <md-button class="md-raised md-success" @click="addBed()">Add </md-button>
                          </div>
                        </div>
                      </md-card-content>
                    </md-card>
                  </form>
                  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <md-card id="bad_types_table">
                      <md-card-header data-background-color="purple">
                        <h4 class="title">Rooms</h4>
                        <!-- <p class="category">Here is a subtitle for this table</p> -->
                      </md-card-header>
                      <md-card-content>
                        <md-table v-model="rooms" table-header-color="green">
                          <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell md-label="Bed type">{{ getBedTypeName(item.bed_type_id) }}</md-table-cell>
                            <md-table-cell md-label="Room number">{{ item.room_number }}</md-table-cell>
                            <md-table-cell md-label="Quantity">{{ item.quantity }}</md-table-cell>
                            <md-table-cell md-label="">
                              <span class="cursor_pointer" @click="deleteBed(item)">
                                <md-icon>delete</md-icon>
                              </span>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </md-card-content>
                    </md-card>
                  </div>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </template>

      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable,
} from "@/components";
import {mapActions} from "vuex";
import Maps from "@/pages/Maps";
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
export default {
  name: "EditListing",
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
    Maps,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
  },
  data() {
    return {
      successMsg: '',
      errors: [],
      isDragging: false,
      isDraggingAttach: false,
      editId: null,
      setAddress: '',
      lat: null,
      lng: null,
      debounceTimer: null,
      isLoading: false,
      isDraftMode: false,

      files: [],
      edit_data: {},
      tagOptions: [],
      personCapacities: [],
      numberOfGuestBathrooms: [],
      propertyTypes: [],
      roomTypes: [],
      bathroomTypes: [],
      numberOfBathrooms: [],
      numberOfBeds: [],
      numberOfBedrooms: [],

      amenities: [],
      selectedAmenities: [],
      selected_amenities: [],
      allBedTypes: [],

      basic_info: {
        external_listing_name: '',
        person_capacity: '',
        tags_ids: [],
        property_type_id: '',
        description: '',
        room_type_id: '',
        number_of_bathrooms: '',
        number_of_beds: '',
        number_of_bedrooms: '',
        bathroom_type_id: '',
        number_of_guest_bathrooms: ''
      },
      address: {
        location: '',
        address: '',
        public_address: '',
        country: '',
        state: '',
        city: '',
        street: '',
        zip_code: '',
        latitude: '',
        longitude: '',
      },
      price_and_fees: {
        currency_code: '',
        price: '',
        price_fo_extra_person: '',
        guests_included: '',
        refundable_damage_deposit: '',
        cleaning_fee: '',
        weekly_discount: '',
        monthly_discount: '',
      },
      selected_reservation: [],
      exclude_from_reservation: [
        {
          name: 'Exclude from reservation sum',
          exclude_from_reservation_sum: 1
        }
      ],
      allCountries: [],
      additional_info: {
        house_rules: '',
        house_manual: '',
        cleaning_instruction: '',
        key_pickup: '',
        special_instruction: '',
        door_code: '',
        bed_type: '',
        wi_fi_username: '',
        wi_fi_password: '',
        listings_cleanliness_status: '',
        check_in_time_start: '',
        check_in_time_end: '',
        check_out_time: '',
      },
      contact_invoicing: {
        contact_name: '',
        contact_surname: '',
        phone_number: '',
        second_phone_number: '',
        contact_language: '',
        contact_email: '',
        contact_address: '',
        tax_id: ''
      },
      booking_settings: {
        minimum_nights: 1,
        maximum_nights: 1,
        enable_reservations_for_gap_nights: 1,
        smallest_allowed_gap: 1,
        allow_gaps_between_start: 1,
        allow_gaps_between_end: 1,
      },
      rooms: [],
      newRoom: {
        bed_type_id: null,
        room_number: null,
        quantity: null
      },
      additional_info_checked: [],
      times: [],
      attachments: [],
      additional_info_checkbox: [
        {
          name: 'Automatically generate a door code',
          automatically_generate_a_door_cod: 1,
        },
        {
          name: 'Phone number-based code (If supported by lock)',
          phone_number_based_code: 1,
        }
      ],
    }
  },
  watch: {
    // Watch for changes in selected amenities
    // selected_amenities: {
    //   handler(newSelection, oldSelection) {
    //     console.log('Amenities selection changed:', {
    //       old: oldSelection.length,
    //       new: newSelection.length,
    //       selected: newSelection.map(a => a.name)
    //     });
    //   },
    //   deep: true
    // }
  },
  computed: {
    currencyOptions() {
      const seen = new Set();

      return this.allCountries
          .filter(c => c.currencies && c.currencies[0])
          .map(c => ({
            code: c.currencies[0].code,
            name: c.name
          }))
          .filter(option => {
            if (seen.has(option.code)) return false;
            seen.add(option.code);
            return true;
          });
    },

    // Get selected tag names for display
    selectedTagNames() {
      return this.basic_info.tags_ids.map(tagId => this.getTagName(tagId));
    },

    // Get selected amenity objects for display
    // selectedAmenityNames() {
    //   return this.selected_amenities.map(amenity => amenity.name);
    // },

    // Count selected amenities
    selectedAmenityCount() {
      return this.amenities.filter(a => a.checked).length;
    },

    // Get amenities formatted for saving
    // amenitiesForSave() {
    //   const result = {};
    //   this.selected_amenities.forEach(amenity => {
    //     const key = Object.keys(amenity).find(k => k !== 'name' && k !== 'id');
    //     if (key) {
    //       result[key] = 1;
    //     }
    //   });
    //   return result;
    // },

  },

  created() {

  },
  mounted() {
    this.isLoading = true;
    this.getListingSettings()
        .then(res => {
          this.listingSettings = res.data.data
          this.personCapacities = res.data.data.person_capacities
          this.propertyTypes = res.data.data.property_types
          this.roomTypes = res.data.data.room_types
          this.numberOfBedrooms = res.data.data.number_of_bedrooms
          this.numberOfBeds = res.data.data.number_of_beds
          this.numberOfBathrooms = res.data.data.number_of_bathrooms
          this.bathroomTypes = res.data.data.bathroom_types
          this.numberOfGuestBathrooms = res.data.data.number_of_guest_bathrooms
          this.times = res.data.data.times
          this.allBedTypes = res.data.data.bed_types
          this.allCountries = res.data.data.countries
          this.tagOptions = res.data.data.tags
          this.$nextTick(() => {
            if (!Array.isArray(this.basic_info.tags_ids)) this.basic_info.tags_ids = [];
          });
          this.amenities = res.data.data.amenities.map(amenity => ({
            id: amenity.id,
            name: amenity.name,
            key: this.generateAmenityKey(amenity.name),
            checked: false
          }))
          
          // Загружаем данные листинга только после того, как amenities загружены
          this.fetchListing();
          
          this.isLoading = false;
        })
        .catch(err => {
          console.error('Error loading listing settings:', err);
          this.isLoading = false;
        });
  },
  methods: {
    ...mapActions([
        'getListingById',
        'getListingSettings',
        'getTags',
        'getBedTypes',
        'getGuestBathroomNumber',
        'getPersonCapacities',
        'getPropertyTypes',
        'getRoomTypes',
        'getBathroomTypes',
        'getBathroomNumbers',
        'getBedroomsNumber',
        'getBedNumbers',
        'getCountries',
        'getTimes',
        'createListing',
        'getMediaData',
        'removeMedia',
        'addMediaImage',
        'getListAmenities'
    ]),
    // Check if tags are selected
    hasSelectedTags() {
      return this.basic_info.tags_ids && this.basic_info.tags_ids.length > 0;
    },
    getBedTypeName(id) {
      if (!id) return 'Unknown';
      // Поддерживаем разные форматы: число или объект
      const bedTypeId = typeof id === 'object' && id !== null ? (id.id || id.bed_type_id) : id;
      if (!bedTypeId) return 'Unknown';
      
      const type = this.allBedTypes.find(b => b.id === bedTypeId);
      return type ? type.name : 'Unknown';
    },
    onTagSelected(selectedTag) {
      this.basic_info.tags_ids.push(selectedTag)
    },
    // Handle when tags dropdown opens
    onTagsOpened() {
      this.isTagsOpen = true;
    },

    // Handle when tags dropdown closes
    onTagsClosed() {
      this.isTagsOpen = false;
    },
    // Remove a specific tag
    removeTag(tagId) {
      const index = this.basic_info.tags_ids.indexOf(tagId);
      if (index > -1) {
        this.basic_info.tags_ids.splice(index, 1);
      }
    },

    // Get tag name by ID for display
    getTagName(tagId) {
      const tag = this.tagOptions.find(tag => tag.id === tagId);
      return tag ? tag.name : 'Unknown Tag';
    },

    // Clear all selected tags
    clearAllTags() {
      this.basic_info.tags_ids = [];
    },
    // Populate amenities when editing (called in mounted or when edit data is loaded)
    // populateSelectedAmenities() {
    //   this.selected_amenities = this.amenities.filter((amenity) => {
    //     const key = Object.keys(amenity).find((k) => k !== 'name' && k !== 'id');
    //     return this.edit_data.amenities?.[key] === 1;
    //   });
    //
    //   console.log('Populated selected amenities:', this.selected_amenities);
    // },
    // Get icon for amenity based on name
    getAmenityIcon(amenityName) {
      const iconMap = {
        'Pets allowed': 'pets',
        'Beach front': 'beach_access',
        'Free WiFi': 'wifi',
        'Air condition': 'ac_unit',
        'Street parking': 'local_parking',
        'Swimming pool': 'pool',
        'Kitchen': 'kitchen',
        'Washing machine': 'local_laundry_service',
        'Hot tub': 'hot_tub',
        'Suitable for children': 'child_friendly'
      };
      return iconMap[amenityName] || 'check_circle';
    },
    generateAmenityKey(name) {
      // Преобразуем название в snake_case ключ
      let key = name
          .replace(/([a-z])([A-Z])/g, '$1_$2')
          .toLowerCase()
          .replace(/\s+/g, '_')
          .replace(/[^a-z0-9_]/g, '')
          .replace(/_+/g, '_')
          .replace(/^_|_$/g, '');
      return key;
    },

    // Handle amenity selection from table
    // onSelect(selectedItems) {
    //   this.selected_amenities = selectedItems;
    //   console.log('Selected amenities:', this.selected_amenities);
    // },
    // Toggle individual amenity (alternative to table selection)
    // toggleAmenity(amenity) {
    //   const index = this.selected_amenities.findIndex(item => item.id === amenity.id);
    //   if (index > -1) {
    //     this.selected_amenities.splice(index, 1);
    //   } else {
    //     this.selected_amenities.push(amenity);
    //   }
    // },

    // Check if amenity is selected
    // isAmenitySelected(amenity) {
    //   return this.selected_amenities.some(item => item.id === amenity.id);
    // },

    // Clear all selected amenities
    // clearAllAmenities() {
    //   this.selected_amenities = [];
    // },

    // Select all amenities
    // selectAllAmenities() {
    //   this.selected_amenities = [...this.amenities];
    // },
    async onChangeAttach() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.fileAttach.files);
      
      if (!this.edit_data.id) {
        alert("Listing ID is missing. Please save the listing first.");
        self.$refs.fileAttach.value = "";
        return;
      }
      
      // Проверяем на дубликаты
      const fileExist = self.attachments.some((r) =>
          incomingFiles.some(
              (file) => file.name === r.name && file.size === r.size
          )
      );
      
      if (fileExist) {
        alert("New upload contains files that already exist.");
        self.$refs.fileAttach.value = "";
        return;
      }

      // Валидируем и загружаем файлы через API
      let uploadedCount = 0;
      for (const file of incomingFiles) {
        // Валидация для PDF файлов
        if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
          alert(`${file.name}: Only PDF format is allowed for attachments.`);
          continue;
        }

        try {
          const maxSequence = self.attachments.length > 0 
            ? Math.max(...self.attachments.map(a => Number(a.sequence) || 0))
            : 0;
          
          let sendData = {
            type: 'attachment',
            file: file,
            listing_id: this.edit_data.id,
            sequence: maxSequence + uploadedCount + 1,
            is_public: 1
          };
          
          const res = await this.addMediaImage(sendData);
          if (res && (res.status === 200 || res.status === 201)) {
            uploadedCount++;
          } else {
            alert(`Failed to upload ${file.name}`);
          }
        } catch (error) {
          console.error(`Error uploading ${file.name}:`, error);
          alert(`Error uploading ${file.name}. Please try again.`);
        }
      }
      
      // Обновляем список attachments после загрузки всех файлов
      if (uploadedCount > 0) {
        await this.getAttachments();
      }
      
      self.$refs.fileAttach.value = "";
    },

    async removeAttach(index) {
      if (index < 0 || index >= this.attachments.length) {
        console.error('Invalid attachment index');
        return;
      }

      const attachment = this.attachments[index];
      
      // Если это новый файл (еще не загружен на сервер), просто удаляем из массива
      if (attachment instanceof File || !attachment.id) {
        // Очищаем URL если он был создан
        if (attachment.src) {
          URL.revokeObjectURL(attachment.src);
        }
        this.attachments.splice(index, 1);
        return;
      }

      // Если это существующий файл, удаляем через API
      try {
        const sendData = {
          id: attachment.id,
          listing_id: this.edit_data.id
        };
        
        const res = await this.removeMedia(sendData);
        if (res && (res.status === 200 || res.status === 201)) {
          // Очищаем URL если он был создан
          if (attachment.src) {
            URL.revokeObjectURL(attachment.src);
          }
          await this.getAttachments();
        } else {
          this.errors = ['Failed to remove attachment file'];
        }
      } catch (error) {
        console.error('Error removing attachment:', error);
        this.errors = ['Failed to remove attachment file'];
      }
    },
    dragoverAttach(e) {
      e.preventDefault();
      this.isDraggingAttach = true;
    },
    dragleaveAttach() {
      this.isDraggingAttach = false;
    },
    dropAttach(e) {
      e.preventDefault();
      this.$refs.fileAttach.files = e.dataTransfer.files;
      this.onChangeAttach();
      this.isDraggingAttach = false;
    },

    async fetchListing() {
      const id = this.$route.params.id;
      if (!id) {
        this.errors = ['Listing ID is missing'];
        this.isLoading = false;
        return;
      }

      try {
        const res = await this.getListingById(id);
        
        // Проверяем на ошибки в ответе
        if (res.response && res.response.status !== 200) {
          const errorMessage = res.response.data?.message || 
                              res.response.data?.error || 
                              'Failed to load listing';
          this.errors = Array.isArray(res.response.data?.errors) 
            ? res.response.data.errors 
            : [errorMessage];
          this.isLoading = false;
          console.error('Error loading listing:', res.response.data);
          return;
        }

        // Проверяем наличие данных
        if (!res.data || !res.data.data) {
          this.errors = ['Listing data not found'];
          this.isLoading = false;
          return;
        }

        this.edit_data = res.data.data;
        
        // Basic info
        this.basic_info.external_listing_name = this.edit_data.external_listing_name || '';
        this.basic_info.description = this.edit_data.description || '';
        this.basic_info.person_capacity = this.edit_data.person_capacity || '';
        this.basic_info.property_type_id = this.edit_data.property_type?.id || '';
        this.basic_info.room_type_id = this.edit_data.room_type?.id || '';
        this.basic_info.number_of_bedrooms = this.edit_data.number_of_bedrooms || '';
        this.basic_info.number_of_beds = this.edit_data.number_of_beds || '';
        this.basic_info.number_of_bathrooms = this.edit_data.number_of_bathrooms || '';
        this.basic_info.bathroom_type_id = this.edit_data.bathroom_type?.id || '';
        this.basic_info.number_of_guest_bathrooms = this.edit_data.number_of_guest_bathrooms || '';
        
        // Tags
        if (this.edit_data.tags && typeof this.edit_data.tags === 'object') {
          this.basic_info.tags_ids = [];
          for(const [key, value] of Object.entries(this.edit_data.tags)) {
            if (value && value.id) {
              this.onTagSelected(value.id);
            }
          }
        }
        
        // Address
        if (this.edit_data.address) {
          this.address.address = this.edit_data.address.address || '';
          this.address.city = this.edit_data.address.city || '';
          this.address.country = this.edit_data.address.country || '';
          this.address.public_address = this.edit_data.address.public_address || '';
          this.address.state = this.edit_data.address.state || '';
          this.address.street = this.edit_data.address.street || '';
          this.address.zip_code = this.edit_data.address.zip_code || '';
          this.address.latitude = this.edit_data.address.latitude || '';
          this.address.longitude = this.edit_data.address.longitude || '';
          
          // Устанавливаем координаты для карты
          if (this.edit_data.address.latitude && this.edit_data.address.longitude) {
            this.lat = parseFloat(this.edit_data.address.latitude);
            this.lng = parseFloat(this.edit_data.address.longitude);
            this.setAddress = [
              this.address.address,
              this.address.city,
              this.address.state,
              this.address.country
            ].filter(Boolean).join(' ');
          }
        }

        // Amenities
        // Загружаем существующие amenities после того, как список amenities загружен из API
        if (this.edit_data.amenities) {
          if (this.amenities.length > 0) {
            this.loadExistingAmenities(this.edit_data.amenities);
          } else {
            console.warn('fetchListing: amenities list is empty when trying to load existing amenities');
          }
        }
        
        // Media
        this.getMedia();
        
        // Attachments
        this.getAttachments();

        // Price and fees
        if (this.edit_data.price_and_fee) {
          this.price_and_fees.price = this.edit_data.price_and_fee.price || '';
          this.price_and_fees.currency_code = this.edit_data.price_and_fee.currency_code || '';
          this.price_and_fees.price_fo_extra_person = this.edit_data.price_and_fee.price_fo_extra_person || '';
          this.price_and_fees.guests_included = this.edit_data.price_and_fee.guests_included || '';
          this.price_and_fees.refundable_damage_deposit = this.edit_data.price_and_fee.refundable_damage_deposit || '';
          this.price_and_fees.cleaning_fee = this.edit_data.price_and_fee.cleaning_fee || '';
          this.price_and_fees.weekly_discount = this.edit_data.price_and_fee.weekly_discount || '';
          this.price_and_fees.monthly_discount = this.edit_data.price_and_fee.monthly_discount || '';
        }

        // Additional info
        if (this.edit_data.additional_info) {
          this.additional_info.house_rules = this.edit_data.additional_info.house_rules || '';
          this.additional_info.house_manual = this.edit_data.additional_info.house_manual || '';
          this.additional_info.key_pickup = this.edit_data.additional_info.key_pickup || '';
          this.additional_info.special_instruction = this.edit_data.additional_info.special_instruction || '';
          this.additional_info.door_code = this.edit_data.additional_info.door_code || '';
          this.additional_info.bed_type = this.edit_data.additional_info.bed_type || '';
          this.additional_info.listings_cleanliness_status = this.edit_data.additional_info.listings_cleanliness_status || '';
          this.additional_info.cleaning_instruction = this.edit_data.additional_info.cleaning_instruction || '';
          this.additional_info.wi_fi_username = this.edit_data.additional_info.wi_fi_username || '';
          this.additional_info.wi_fi_password = this.edit_data.additional_info.wi_fi_password || '';
          this.additional_info.check_in_time_start = this.edit_data.additional_info.check_in_time_start || '';
          this.additional_info.check_in_time_end = this.edit_data.additional_info.check_in_time_end || '';
          this.additional_info.check_out_time = this.edit_data.additional_info.check_out_time || '';
        }

        // Contact and invoicing
        // Поддерживаем разные форматы данных: contact_person_and_invoicing_info, contact, или прямое обращение
        const contactData = this.edit_data.contact_person_and_invoicing_info || 
                           this.edit_data.contact || 
                           this.edit_data.contact_invoicing ||
                           {};
        
        if (contactData && Object.keys(contactData).length > 0) {
          this.contact_invoicing.contact_name = contactData.contact_name || '';
          this.contact_invoicing.contact_surname = contactData.contact_surname || '';
          this.contact_invoicing.phone_number = contactData.phone_number || '';
          this.contact_invoicing.second_phone_number = contactData.second_phone_number || '';
          this.contact_invoicing.contact_language = contactData.contact_language || '';
          this.contact_invoicing.contact_email = contactData.contact_email || '';
          this.contact_invoicing.contact_address = contactData.contact_address || '';
          this.contact_invoicing.tax_id = contactData.tax_id || '';
        }

        // Booking settings
        if (this.edit_data.booking_settings) {
          this.booking_settings.minimum_nights = this.edit_data.booking_settings.minimum_nights || '';
          this.booking_settings.maximum_nights = this.edit_data.booking_settings.maximum_nights || '';
          this.booking_settings.enable_reservations_for_gap_nights = this.edit_data.booking_settings.enable_reservations_for_gap_nights || 0;
          this.booking_settings.smallest_allowed_gap = this.edit_data.booking_settings.smallest_allowed_gap || '';
          this.booking_settings.allow_gaps_between_start = this.edit_data.booking_settings.allow_gaps_between_start || '';
          this.booking_settings.allow_gaps_between_end = this.edit_data.booking_settings.allow_gaps_between_end || '';
        }

        // Rooms - нормализуем структуру данных из API
        // API возвращает: { id, room_number, quantity, type: { id, name } }
        // Нормализуем в: { id?, bed_type_id, room_number, quantity }
        if (this.edit_data.rooms && Array.isArray(this.edit_data.rooms)) {
          this.rooms = this.edit_data.rooms.map(room => {
            // Извлекаем bed_type_id из разных возможных структур
            let bed_type_id = null;
            if (room.type && room.type.id) {
              // Структура из API: type.id
              bed_type_id = room.type.id;
            } else if (room.bed_type_id) {
              // Прямое значение
              bed_type_id = room.bed_type_id;
            } else if (room.bed_type && room.bed_type.id) {
              // Вложенный объект bed_type.id
              bed_type_id = room.bed_type.id;
            }
            
            return {
              id: room.id || null, // Сохраняем id существующей записи для удаления через API
              bed_type_id: bed_type_id,
              room_number: room.room_number || '',
              quantity: room.quantity || ''
            };
          });
        } else {
          this.rooms = [];
        }
        this.editId = this.edit_data.id;
        
        this.isLoading = false;
      } catch (error) {
        console.error('Error fetching listing:', error);
        this.errors = ['Failed to load listing. Please try again.'];
        this.isLoading = false;
      }
    },
    loadExistingAmenities(apiAmenities) {
      if (!apiAmenities) {
        console.warn('loadExistingAmenities: apiAmenities is null or undefined');
        return;
      }

      if (this.amenities.length === 0) {
        console.warn('loadExistingAmenities: amenities list is empty, cannot load existing amenities');
        return;
      }

      // API возвращает массив объектов: [{id: 1, name: "Pets allowed"}, {id: 2, name: "Beach Front"}]
      if (Array.isArray(apiAmenities)) {
        const amenityIds = apiAmenities.map(a => a.id || a).filter(id => id !== null && id !== undefined);
        this.amenities.forEach(a => {
          a.checked = amenityIds.includes(a.id);
        });
        console.log('Loaded existing amenities from array:', amenityIds.length, 'amenities');
      } else if (typeof apiAmenities === 'object') {
        // Fallback для старого формата (объект с ключами)
        let checkedCount = 0;
        this.amenities.forEach(a => {
          const isChecked = apiAmenities[a.key] === 1 || apiAmenities[a.id] === 1 || apiAmenities[a.name] === 1;
          a.checked = isChecked;
          if (isChecked) checkedCount++;
        });
        console.log('Loaded existing amenities from object:', checkedCount, 'amenities');
      } else {
        console.error('loadExistingAmenities: unexpected format', typeof apiAmenities, apiAmenities);
      }
    },
    getSelectedAmenities() {
      // Возвращаем массив объектов с id для отправки в API
      // Store ожидает: [{id: 1}, {id: 2}]
      return this.amenities
        .filter(a => a.checked)
        .map(a => ({ id: a.id }));
    },
    generateURL(file) {
      // Если это новый файл (File объект)
      if (file instanceof File || (file.type && !file.url && !file.file_url && !file.path && !file.image_path)) {
        if (!file.url && !file.src) {
          file.url = file.src = URL.createObjectURL(file);
        }
        return file.url || file.src;
      }
      // Если это существующий файл с URL
      if (file.url) {
        return file.url;
      }
      if (file.src) {
        return file.src;
      }
      if (file.file_url) {
        return file.file_url;
      }
      // Если это файл с путем от сервера
      if (file.path || file.image_path) {
        return file.path || file.image_path;
      }
      return '';
    },
    onSelectAdditional:function (items) {
      this.additional_info_checked = items.map(item => {
        const { name, ...valuesOnly } = item;
        return valuesOnly;
      });
    },
    onSelectReservation:function (items) {
      this.selected_reservation = items;
    },
    async getMedia() {
      if (!this.edit_data.id) {
        console.error('Listing ID is missing');
        return;
      }
      
      try {
        const res = await this.getMediaData(this.edit_data.id);
        if (res && res.data && res.data.images) {
          this.files = res.data.images.map(img => ({
            ...img,
            image_sequences: img.image_sequences || img.sequence || 0,
            vrbo_caption: img.vrbo_caption || '',
            engine_caption: img.engine_caption || ''
          }));
        }
      } catch (error) {
        console.error('Error loading media:', error);
        this.errors = ['Failed to load media files'];
      }
    },
    async getAttachments() {
      if (!this.edit_data.id) {
        console.error('Listing ID is missing');
        return;
      }
      
      try {
        const res = await this.getMediaData(this.edit_data.id);
        if (res && res.data && res.data.attachments) {
          console.log(res.data.attachments, '_attachments');
          this.attachments = res.data.attachments.map(attach => ({
            ...attach,
            attachments_is_public: attach.is_public || attach.attachments_is_public || 0,
            file_url: attach.file_url || attach.path || attach.url || ''
          }));
        }
      } catch (error) {
        console.error('Error loading attachments:', error);
        this.errors = ['Failed to load attachment files'];
      }
    },
    async remove(index) {
      if (index < 0 || index >= this.files.length) {
        console.error('Invalid file index');
        return;
      }

      const file = this.files[index];
      
      // Если это новый файл (еще не загружен на сервер), просто удаляем из массива
      if (file instanceof File || !file.id) {
        // Очищаем URL если он был создан
        if (file.url) {
          URL.revokeObjectURL(file.url);
        }
        this.files.splice(index, 1);
        return;
      }

      // Если это существующий файл, удаляем через API
      try {
        const sendData = {
          id: file.id,
          listing_id: this.edit_data.id
        };
        
        const res = await this.removeMedia(sendData);
        if (res && (res.status === 200 || res.status === 201)) {
          // Очищаем URL если он был создан
          if (file.url) {
            URL.revokeObjectURL(file.url);
          }
          await this.getMedia();
        } else {
          this.errors = ['Failed to remove media file'];
        }
      } catch (error) {
        console.error('Error removing media:', error);
        this.errors = ['Failed to remove media file'];
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
    async onChange() {
      const self = this;
      let incomingFiles = Array.from(this.$refs.file.files);
      
      if (!this.edit_data.id) {
        alert("Listing ID is missing. Please save the listing first.");
        self.$refs.file.value = "";
        return;
      }
      
      // Проверяем на дубликаты
      const fileExist = self.files.some((r) =>
          incomingFiles.some(
              (file) => file.name === r.name && file.size === r.size
          )
      );
      
      if (fileExist) {
        alert("New upload contains files that already exist.");
        self.$refs.file.value = "";
        return;
      }

      // Валидируем и загружаем файлы через API
      let uploadedCount = 0;
      for (const file of incomingFiles) {
        const isValid = await self.validateImage(file);
        if (isValid) {
          try {
            const maxSequence = self.files.length > 0 
              ? Math.max(...self.files.map(f => Number(f.image_sequences) || 0))
              : 0;
            
            let sendData = {
              type: 'image',
              file: file,
              listing_id: this.edit_data.id,
              sequence: maxSequence + uploadedCount + 1,
              is_public: 1
            };
            
            const res = await this.addMediaImage(sendData);
            if (res && (res.status === 200 || res.status === 201)) {
              uploadedCount++;
            } else {
              alert(`Failed to upload ${file.name}`);
            }
          } catch (error) {
            console.error(`Error uploading ${file.name}:`, error);
            alert(`Error uploading ${file.name}. Please try again.`);
          }
        }
      }
      
      // Обновляем список медиа после загрузки всех файлов
      if (uploadedCount > 0) {
        await this.getMedia();
      }
      
      self.$refs.file.value = "";
    },
    async validateImage(file) {
      const maxMB = 2;
      const minWidth = 1024;
      const minHeight = 683;

      if (!["image/jpeg", "image/png"].includes(file.type)) {
        alert(`${file.name}: Only JPG and PNG formats are allowed.`);
        return false;
      }

      if (file.size > maxMB * 1024 * 1024) {
        alert(`${file.name}: File exceeds ${maxMB} MB.`);
        return false;
      }

      const hasValidDimensions = await this.checkImageDimensions(file, minWidth, minHeight);
      if (!hasValidDimensions) {
        alert(`${file.name}: Minimum size is ${minWidth}x${minHeight}px.`);
        return false;
      }

      return true;
    },
    checkImageDimensions(file, minWidth, minHeight) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          resolve(img.width >= minWidth && img.height >= minHeight);
        };
        img.onerror = () => resolve(false);
        img.src = URL.createObjectURL(file);
      });
    },
    addBed() {
      if (!this.newRoom.bed_type_id || !this.newRoom.room_number || !this.newRoom.quantity) return;
      this.rooms.push({
        bed_type_id: this.newRoom.bed_type_id,
        room_number: this.newRoom.room_number,
        quantity: this.newRoom.quantity
      })
      this.newRoom = {
        bed_type_id: null,
        room_number: null,
        quantity: null
      };
    },
    deleteBed(item) {
      // Если у записи есть id (существующая запись из API), используем его для поиска
      // Иначе ищем по всем полям
      let index = -1;
      
      if (item.id) {
        // Существующая запись - ищем по id
        index = this.rooms.findIndex(room => room.id === item.id);
      } else {
        // Новая запись - ищем по всем полям
        index = this.rooms.findIndex(room => 
          room.bed_type_id === item.bed_type_id && 
          room.room_number === item.room_number && 
          room.quantity === item.quantity &&
          !room.id // Только новые записи без id
        );
      }
      
      if (index > -1) {
        this.rooms.splice(index, 1);
      }
    },
    updateData(draft_status) {
      this.isDraftMode = draft_status === 1;

      let all_images = [];
      let all_image_sequences = [];
      
      if (this.files.length) {
        for (const [key, value] of Object.entries(this.files)) {
          // Разделяем новые файлы (File объекты) и существующие (с id)
          if (value instanceof File || !value.id) {
            // Новый файл
            all_images.push(value);
            all_image_sequences.push(Number(value.image_sequences));
          } else {
            // Существующий файл - отправляем image_sequences
            all_image_sequences.push(Number(value.image_sequences) || 0);
          }
        }
      }
      
      let attachments = [];
      let attachments_file_name = [];
      let attachments_is_public = [];
      let selectedAmenity = this.getSelectedAmenities();

      // Attachments теперь загружаются через API (как медиа)
      // Отправляем только новые файлы, если они еще не были загружены
      // И обновления is_public для существующих attachments
      if (this.attachments.length) {
        for (const attachment of this.attachments) {
          // Только новые файлы (File объекты без id) отправляем
          // Остальные уже загружены через API
          if (attachment instanceof File || (!attachment.id && !attachment.file_url)) {
            attachments.push(attachment);
            attachments_file_name.push(attachment.name);
            attachments_is_public.push(attachment.attachments_is_public == 1 ? 1 : 0);
          } else if (attachment.id) {
            // Для существующих attachments отправляем только обновления is_public
            // Это можно обработать отдельным API вызовом или через обновление листинга
            // Пока оставляем пустым, так как основная логика через API
          }
        }
      }
      
      // Сохраняем координаты в address
      if (this.lat && this.lng) {
        this.address.latitude = this.lat;
        this.address.longitude = this.lng;
      }
      
      let sendData = {
        draft: draft_status,
        id: this.editId,
        basic_info: this.basic_info,
        address: this.address,
        selected_amenities: selectedAmenity,
        price_and_fees: this.price_and_fees,
        additional_info: this.additional_info,
        additional_info_checked: this.additional_info_checked,
        contact_invoicing: this.contact_invoicing,
        booking_settings: this.booking_settings,
        rooms: this.rooms,
        images: all_images,
        image_sequences: all_image_sequences,
        attachments: attachments,
        attachments_file_name: attachments_file_name,
        attachments_is_public: attachments_is_public
      };
      
      this.isLoading = true;
      this.createListing(sendData)
          .then(res => {
            this.isLoading = false;
            if (res.response && res.response.status !== 200) {
              this.errors = res.response.data?.errors || ['Failed to update listing'];
              this.$nextTick(() => {
                const errorElement = document.querySelector('.text-danger');
                if (errorElement) {
                  errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              });
            } else {
              this.successMsg = `Your listing was ${sendData.draft == 1 ? 'updated' : 'published'} successfully.`;
              setTimeout(() => {
                this.successMsg = "";
                this.$router.push('/admin/listings');
              }, 3000);
            }
          })
          .catch(err => {
            this.isLoading = false;
            console.error('Error updating listing:', err);
            this.errors = ['An error occurred while updating the listing. Please try again.'];
          });
      
      return true;
    },
    checkMap() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        let address_line = {
          address: this.address.address,
          city: this.address.city,
          country: this.address.country,
          state: this.address.state
        }
        this.setAddress = address_line.address + ' ' + address_line.city + ' ' + address_line.state + ' ' + address_line.country
        this.geocodeAddress();
      }, 800);
    },
    async geocodeAddress() {
      if (!this.setAddress || this.setAddress.trim() === '') {
        alert('Please enter an address');
        return;
      }
      // const mapboxToken = 'pk.eyJ1IjoibWluZ3lhbjIxNCIsImEiOiJja2h4Y2xiajAwMTBsMnZuNHBzMjVmYjlsIn0.w7Wxvvi2i4olHVL2gE1zkQ';
      const encoded = encodeURIComponent(this.setAddress);
      // const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encoded}.json?access_token=${mapboxToken}`;
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encoded}`;

      try {
        const res = await fetch(url, {
          headers: {
            'User-Agent': 'STRWeb/1.0 (your-email@example.com)' // Nominatim requires a user agent
          }
        });
        const data = await res.json();
        if (data && data.length > 0) {
          this.lat = parseFloat(data[0].lat);
          this.lng = parseFloat(data[0].lon);

          this.$nextTick(() => {
            console.log('Coordinates set:', this.lat, this.lng);
          });
        } else {
          // alert('Address not found or no results returned.');
          this.lat = null;
          this.lng = null;
        }
      } catch (err) {
        console.error("Geocoding error:", err);
        alert('An error occurred while geocoding the address.');
        this.lat = null; // Clear previous coordinates on error
        this.lng = null;
      }
    },
  },
  beforeDestroy() {
    // Очищаем все созданные URL для предотвращения утечек памяти
    this.files.forEach(file => {
      if (file.url && file.url.startsWith('blob:')) {
        URL.revokeObjectURL(file.url);
      }
    });
    this.attachments.forEach(attach => {
      if (attach.src && attach.src.startsWith('blob:')) {
        URL.revokeObjectURL(attach.src);
      }
    });
    // Очищаем таймер
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .currency_code {
  width: 100%;
  border: none !important;
  & .vs__dropdown-toggle {
    border: none !important;
  }
}
.media, .attachment {
  &_tab {
    min-height: 50vh;
    & .dropzone {
      &_container {
        padding: 20px;
        background: #f7fafc;
        border: 2px dashed #9e9e9e;
        width: 400px;
        height: 100px;
      }
      &_input {
        opacity: 0;
        overflow: hidden;
        position: absolute;
        width: 1px;
        height: 1px;
      }
      &_label {
        font-size: 18px;
        display: block;
        cursor: pointer;
        text-align: center;
      }
    }
  }
  &_main {
    display: flex;
    margin-top: 10px;
    & .preview {
      &_container {
        display: flex;
        flex-wrap: wrap;
        & .md-field {
          padding-top: 8px;
          margin-bottom: 0;
          min-height: 45px;
        }
      }
      &_card {
        display: flex;
        border: 1px solid #a2a2a2;
        padding: 12px;
        margin-right: 20px;
        margin-bottom: 20px;
        width: 370px;
        height: 420px;
        position: relative;
        &-item {
          width: 100%;
          & embed {
            height: 75%;
          }
        }
        &_input {
          &-item {
            padding: 5px 0;
          }
        }
        &-close {
          position: absolute;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 2px solid lightgray;
          top: 5px;
          right: 5px;
        }
      }
      &_img {
        width: 100%;
        height: 200px;
        border-radius: 5px;
        border: 1px solid #a2a2a2;
        background-color: #a2a2a2;
      }
    }
  }
}

.amenities-actions {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.amenities-table-container {
  .md-table {
    margin-top: 0;
  }

  .selected-amenity-row {
    background-color: #e8f5e8 !important;
  }

  .amenity-item {
    display: flex;
    align-items: center;
    gap: 12px;

    .amenity-icon {
      font-size: 20px;
    }

    .amenity-name {
      font-weight: 500;
    }
  }
}

// Alternative grid layout styles
.amenities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 16px;

  .amenity-card {
    cursor: pointer;
    transition: all 0.2s ease;
    border: 2px solid transparent;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.12);
    }

    &.selected {
      border-color: #4caf50;
      background-color: #e8f5e8;
    }

    .amenity-content {
      display: flex;
      align-items: center;
      gap: 8px;

      .amenity-checkbox {
        margin: 0;
      }

      .amenity-icon {
        color: #666;
        font-size: 18px;
      }

      .amenity-name {
        font-size: 14px;
        font-weight: 500;
      }
    }
  }
}

.selected-amenities-summary {
  border-top: 1px solid #e0e0e0;
  padding-top: 16px;

  h5 {
    margin-bottom: 12px;
    color: #333;
  }

  .selected-amenities-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;

    .md-chip {
      background-color: #e3f2fd !important;
      color: #1976d2 !important;

      .md-icon {
        font-size: 16px;
      }
    }
  }
}

.no-amenities-selected {
  text-align: center;
  padding: 32px 16px;
  border-top: 1px solid #e0e0e0;

  p {
    color: #666;
    margin: 0;
  }
}
.success_msg {
  margin: 10px;
  line-height: 42px;
  display: inline-block;
  color: green;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-spinner {
  text-align: center;
  
  p {
    margin-top: 20px;
    font-size: 16px;
    color: #666;
  }
}

.cursor_pointer {
  cursor: pointer;
  
  &:hover {
    opacity: 0.7;
  }
}

::v-deep #bad_types_table table thead {
  display: table-header-group !important;
}
</style>
